import { Cookies } from '@affstore-ds/helpers'

export const removeCookies = () => {
  Cookies.deleteCookie('token')
  Cookies.deleteCookie('aff_sid')
  Cookies.deleteCookie('aff_ssid')
}
